/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { BillingAddress } from './billing-address';
// May contain unused imports in some cases
// @ts-ignore
import type { Customer } from './customer';
// May contain unused imports in some cases
// @ts-ignore
import type { OrderDetails } from './order-details';

/**
 * Request to create a payment intent. **Fee constraint:** The sum of `platformFees` + `serviceFees` must not exceed `totalAmount - (platformFees + serviceFees)`. In other words, the merchant\'s portion (totalAmount minus all fees) must be at least as large as the combined fees. Requests violating this constraint will be rejected with error code `FEES_EXCEED_MERCHANT_AMOUNT`. 
 * @export
 * @interface CreatePaymentIntentRequest
 */
export interface CreatePaymentIntentRequest {
    /**
     * Merchant account ID that the payment intent is for
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'merchantId': string;
    /**
     * Total payment amount in minor units (e.g., cents for USD, pence for GBP) This should be the total of the amount to pay the merchant + service fees + processor 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'totalAmount': number;
    /**
     * Fees that are collected by the partner
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'serviceFees': number;
    /**
     * Fees that are collected by the FanFair platform
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'platformFees': number;
    /**
     * ISO 4217 currency code. Only USD currently supported
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'currency': CreatePaymentIntentRequestCurrencyEnum;
    /**
     * The reference for the transaction. This will appear on the customer\'s statement. Can only contain letters, numbers and spaces 
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'merchantReference': string;
    /**
     * URL to redirect customer after successful payment
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'returnUrl'?: string;
    /**
     * URL to redirect customer if payment is cancelled
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'cancelUrl'?: string;
    /**
     * Optional description of the payment
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Customer}
     * @memberof CreatePaymentIntentRequest
     */
    'customer'?: Customer;
    /**
     * 
     * @type {BillingAddress}
     * @memberof CreatePaymentIntentRequest
     */
    'billingAddress'?: BillingAddress;
    /**
     * 
     * @type {OrderDetails}
     * @memberof CreatePaymentIntentRequest
     */
    'orderDetails'?: OrderDetails;
    /**
     * Arbitrary key-value pairs for merchant use. Keys must be max 100 characters and cannot contain square brackets. Values must be max 500 characters.
     * @type {{ [key: string]: string; }}
     * @memberof CreatePaymentIntentRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * Optional custom timeout for the payment session in minutes. If not provided, defaults to 45 minutes. Minimum: 5 minutes, Maximum: 180 minutes (3 hours). The timeout value determines how long the session remains valid before expiring. After expiration, the session cannot be used for payment processing. 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'timeoutInMinutes'?: number;
}

export const CreatePaymentIntentRequestCurrencyEnum = {
    Usd: 'USD'
} as const;

export type CreatePaymentIntentRequestCurrencyEnum = typeof CreatePaymentIntentRequestCurrencyEnum[keyof typeof CreatePaymentIntentRequestCurrencyEnum];


